/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Achievementsxplabel2Inputs */

const id_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const ms_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const da_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const de_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const en_us2_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const es_es2_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const es_mx2_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const fil_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const fr_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const it_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const hu_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const nl_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const no_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const pl_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const pt_br2_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const pt_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const ro_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const fi_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const sv_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const vi_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const tr_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const cs_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const bg_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const ru_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опыт (XP)`)
};

const uk_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const ar_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const hi_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const th_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const ja_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

const zh_cn2_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`经验值`)
};

const zh_hant1_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`經驗值`)
};

const ko_sandboxes_achievementsxplabel2 = /** @type {(inputs: Sandboxes_Achievementsxplabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XP`)
};

/**
* | output |
* | --- |
* | "XP" |
*
* @param {Sandboxes_Achievementsxplabel2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_achievementsxplabel2 = /** @type {((inputs?: Sandboxes_Achievementsxplabel2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Achievementsxplabel2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_achievementsxplabel2(inputs)
	if (locale === "ms") return ms_sandboxes_achievementsxplabel2(inputs)
	if (locale === "da") return da_sandboxes_achievementsxplabel2(inputs)
	if (locale === "de") return de_sandboxes_achievementsxplabel2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_achievementsxplabel2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_achievementsxplabel2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_achievementsxplabel2(inputs)
	if (locale === "fil") return fil_sandboxes_achievementsxplabel2(inputs)
	if (locale === "fr") return fr_sandboxes_achievementsxplabel2(inputs)
	if (locale === "it") return it_sandboxes_achievementsxplabel2(inputs)
	if (locale === "hu") return hu_sandboxes_achievementsxplabel2(inputs)
	if (locale === "nl") return nl_sandboxes_achievementsxplabel2(inputs)
	if (locale === "no") return no_sandboxes_achievementsxplabel2(inputs)
	if (locale === "pl") return pl_sandboxes_achievementsxplabel2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_achievementsxplabel2(inputs)
	if (locale === "pt") return pt_sandboxes_achievementsxplabel2(inputs)
	if (locale === "ro") return ro_sandboxes_achievementsxplabel2(inputs)
	if (locale === "fi") return fi_sandboxes_achievementsxplabel2(inputs)
	if (locale === "sv") return sv_sandboxes_achievementsxplabel2(inputs)
	if (locale === "vi") return vi_sandboxes_achievementsxplabel2(inputs)
	if (locale === "tr") return tr_sandboxes_achievementsxplabel2(inputs)
	if (locale === "cs") return cs_sandboxes_achievementsxplabel2(inputs)
	if (locale === "bg") return bg_sandboxes_achievementsxplabel2(inputs)
	if (locale === "ru") return ru_sandboxes_achievementsxplabel2(inputs)
	if (locale === "uk") return uk_sandboxes_achievementsxplabel2(inputs)
	if (locale === "ar") return ar_sandboxes_achievementsxplabel2(inputs)
	if (locale === "hi") return hi_sandboxes_achievementsxplabel2(inputs)
	if (locale === "th") return th_sandboxes_achievementsxplabel2(inputs)
	if (locale === "ja") return ja_sandboxes_achievementsxplabel2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_achievementsxplabel2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_achievementsxplabel2(inputs)
	return ko_sandboxes_achievementsxplabel2(inputs)
});
export { sandboxes_achievementsxplabel2 as "sandboxes.achievementsXpLabel" }